import {  FromEventObservable  } from './FromEventObservable';

export const fromEvent = FromEventObservable.create;


// WEBPACK FOOTER //
// ./~/rxjs/src/observable/fromEvent.ts